import FormattedMessage from 'I18n/components/FormattedMessage';
import { ArchiveIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BulkArchiveButton({
  hasBulkWriteAccess,
  onClick,
  unsafeEmailCount
}) {
  if (!hasBulkWriteAccess) {
    return null;
  }
  const shouldLinkDisabled = unsafeEmailCount > 0;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !shouldLinkDisabled,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.bulkActions.archiveDisabledTooltipWithUnsafeEmails",
      options: {
        count: unsafeEmailCount
      }
    }),
    children: /*#__PURE__*/_jsxs(Link, {
      "data-test-id": "archive-link",
      disabled: shouldLinkDisabled,
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(ArchiveIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.bulkActions.archive"
      })]
    })
  });
}
export default BulkArchiveButton;